require("normalize.css");
require("./src/sass/main.scss");
require("aos/dist/aos.css");
const AOS = require("aos");
const api = require("./gatsby-api-methods");

exports.onInitialClientRender = () => AOS.init();

exports.wrapRootElement = api.wrapWithProvider;
